import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import Typography from '@material-ui/core/Typography';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close'
import { MESSAGE_CLOSED } from "../constants/actionTypes";
import { connect } from "react-redux";
import theme from "../constants/theme";
const { red, green, grey } = theme.palette;
const snackbarStyles = { info: grey, success: green, error: red };

class Popup extends React.Component {

    render() {
        const { showMessage, message: { text = " ??? ", type = "info" } = {}, onMessageClose  } = this.props;
        return (
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
            open={showMessage}
            autoHideDuration={6000}
            onClose={onMessageClose} >
                <SnackbarContent
                    style={ snackbarStyles[type] }
                    message={<Typography style={{ color: "#fff" }} >{text}</Typography>}
                    action={[
                        <IconButton key={String(Math.random())} style={{ color: "#fff" }} onClick={onMessageClose} >
                            <CloseIcon />
                        </IconButton>
                    ]} />
            </Snackbar>
        );
    }
}

const mapStateToProps = state => ({
    showMessage: state.common.showMessage,
    message: state.common.message,
});

const mapDispatchToProps = (dispatch) => ({
    onMessageClose: () => dispatch({ type: MESSAGE_CLOSED })
});

export default connect(mapStateToProps, mapDispatchToProps)(Popup);



// WEBPACK FOOTER //
// ./src/components/Popup.js